import { getCLS } from "./cls";
import { PerformanceObserverEntryTypes } from "./const";
import { getTBT } from "./tbt";
import { EntriesBuffer } from "./utils/buffer";
import { startLSObserver, startLTObserver } from "./utils/observer";

export function startLighthouseObserver() {
    startLSObserver();
    startLTObserver();
}

export const getLighthouseMetrics = ({
    start,
    stop
}: {
    start: number;
    stop: number;
}): { [key: string]: number } => {
    const longTask = EntriesBuffer[PerformanceObserverEntryTypes.LongTask];
    const tbt = longTask ? getTBT(start, stop, longTask) : null;

    // no round as CLS is usually 0-1
    const layoutShift =
        EntriesBuffer[PerformanceObserverEntryTypes.LayoutShift];
    const cls = layoutShift ? getCLS(start, stop, layoutShift) : null;
    return {
        "metric:tbt": tbt ? Math.round(tbt.total) : 0,
        "metric:tbt:observed": tbt ? Math.round(tbt.observed) : 0,
        "metric:cls": cls ?? 0
    };
};
